export const AuthVectorHeader = () => (
  <>
    <h1 className="flex-shrink-0 text-4xl xl:text-5xl 2xl:text-[3.5rem] 3xl:text-7xl align-middle font-thin whitespace-pre-line">
      {`Revolutionize \n vision care`}
    </h1>
    <h2 className="text-base md:text-lg lg:text-xl xl:text-2xl 2xl:text-3xl 3xl:text-[2.125rem] lg:whitespace-pre-line">
      {` Free Tool for Visionary Doctors! \n Seamless Patient Vision \n Management and Monitoring Tool`}
    </h2>
  </>
)
